import HoursDisplay from 'components/util/HoursDisplay';
import { format, isSameDay } from 'date-fns';
import LabelledData from 'pages/timecards/LabelledData';
import { FC } from 'react';
import { GroupedEfforts } from 'types/efforts';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';
import { dateStringToDateObject } from 'utils/parseDate';
import EffortListItem from './EffortListItem';

type Props = {
    date: string;
    effortGroup: GroupedEfforts;
};

const EffortGroup: FC<Props> = ({ date, effortGroup }) => {
    const dateObj = dateStringToDateObject(date);
    const isToday = isSameDay(dateObj, new Date());
    const groupDate = isToday
        ? `${t('time.today')}, ${format(dateObj, t('timecards.list.group-date-format-without-day'))}`
        : format(dateObj, t('timecards.list.group-date-format'));

    return (
        <div className="bg-paper text-fg border-divider overflow-hidden border-t">
            <div className="bg-grey-50 border-divider flex items-center border-b px-4 py-[9px]">
                <div className="text-h5 flex-auto">
                    <div className="flex w-full flex-wrap items-baseline justify-between">
                        <h6 className="text-subtitle2">{groupDate}</h6>
                        <div className="flex gap-2">
                            <LabelledData label="timecards.list.total-time" className="font-semibold">
                                <HoursDisplay value={effortGroup.usedTimeInSeconds / 3600} />
                            </LabelledData>
                        </div>
                    </div>
                </div>
            </div>
            <ul>
                {effortGroup.efforts.map((effort, index) => (
                    <li
                        key={effort.id}
                        className={cn(
                            'relative flex w-full items-center',
                            index !== effortGroup.efforts.length - 1 && 'border-divider border-b bg-clip-padding'
                        )}
                    >
                        <EffortListItem effort={effort} />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default EffortGroup;
